<template>
    <v-app>
        <section class="hero">
            <v-container fluid class="fill-height py-12">
                <v-row align="center" justify="center">
                    <v-col cols="12" md="6" class="text-section">
                        <h1 class="title">Qualidade que energiza confiança</h1>
                        <p class="subtitle">
                            Controle de qualidade inteligente para placas de parceiros no setor de
                            subestações. Mais rastreabilidade, menos retrabalho — resultados consistentes
                            para operações críticas.
                        </p>
                        <div v-if="!$store.getters.isLogged" class="actions">
                            <router-link :to="{ path: '/login' }">
                                <v-btn color="primary" class="white--text" large>
                                    Entrar no sistema
                                    <v-icon right> arrow_right </v-icon>
                                </v-btn>
                            </router-link>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" class="image-section">
                        <v-card elevation="10" class="hero-card">
                            <v-img
                                src="/static/img/home.jpg"
                                alt="Apresentação Elyon — controle de qualidade para subestações"
                                aspect-ratio="1.6"
                                class="rounded"
                                gradient="to bottom, rgba(15,23,42,0.1), rgba(15,23,42,0.35)"
                            ></v-img>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <div class="hero-pattern"></div>
        </section>
    </v-app>
</template>

<script>
export default {
    name: 'Home',
};
</script>

<style scoped>
.hero {
    position: relative;
    min-height: calc(100vh - 64px);
    background: radial-gradient(1200px 600px at 90% -10%, rgba(212, 122, 29, 0.25) 0%, rgba(212, 122, 29, 0.0) 60%),
                            linear-gradient(135deg, #0F172A 0%, #1E293B 60%, #0B1220 100%);
    color: #e5e7eb; /* text-gray-200 */
}

.title {
    font-weight: 800;
    font-size: 2.4rem;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: #f3f4f6; /* text-gray-100 */
}

.subtitle {
    margin-top: 12px;
    font-size: 1.05rem;
    line-height: 1.65;
    color: #cbd5e1; /* text-slate-300 */
}

.actions {
    margin-top: 22px;
}

.hero-card {
    border-radius: 16px;
    overflow: hidden;
    background: #0f172a;
}

.rounded {
    border-radius: 16px;
}

.hero-pattern {
    pointer-events: none;
    position: absolute;
    inset: 0;
    background-image:
        radial-gradient(1px 1px at 10% 15%, rgba(226,232,240,0.08) 0, rgba(226,232,240,0.0) 100%),
        radial-gradient(1px 1px at 20% 80%, rgba(226,232,240,0.06) 0, rgba(226,232,240,0.0) 100%),
        radial-gradient(1px 1px at 75% 30%, rgba(226,232,240,0.05) 0, rgba(226,232,240,0.0) 100%);
}

.text-section {
    padding: 12px 16px;
}

.image-section {
    padding: 12px 16px;
}

@media (min-width: 960px) {
    .title { font-size: 3rem; }
    .subtitle { font-size: 1.125rem; }
}
</style>
